import { ReportHealthDetailCamera } from "api/interfaces/reportInterface.interface";
import * as s from "../CommonStyled";
import LivefeedItem from "./LivefeedItem";
import { useMemo } from "react";

type DualProps = {
  titleHeight?: number;
  columns: number;
  noScroll?: boolean;
  // data: DualModeLivefeedType;
  data?: ReportHealthDetailCamera;
};

const Livefeed = (props: DualProps): JSX.Element => {
  const cameraList = useMemo(() => {
    let list = props.data?.cameras ?? [];
    const isNvr = (list.at(0)?.channel || 0) > -1;
    if (isNvr) {
      list = list.sort((a, b) => a.channel - b.channel).map((item) => ({
        ...item,
        name: `[${item.channel + 1}] ${item.name}`
      }));
    }
    return list;
  }, [props.data]);
  return (
    <s.FeedWrapper
      titleHeight={props.titleHeight}
      noScroll={props.noScroll ? props.noScroll : false}
    >
      {props.data?.cameras !== undefined && (
        <s.LivefeedWrapper columns={props.columns}>
          {cameraList.map((data, index) => (
            <LivefeedItem
              key={index}
              data={data}
              columns={props.columns}
              isProtected={data.covert}
            />
          ))}
        </s.LivefeedWrapper>
      )}
    </s.FeedWrapper>
  );
};

export default Livefeed;
